import { Alert, Input, Modal } from 'components'
import { Dispatch, SetStateAction } from 'react'
import { Controller, useFormContext } from 'react-hook-form'

import * as S from './styles'

interface ModalConfirmationProps {
  isOpen: boolean
  isMultiple?: boolean
  isReject: boolean
  setIsOpen: Dispatch<SetStateAction<boolean>>
  handleContinue: () => void
  handleReturnAction: () => void
  hasAuthority: boolean
}

const ModalConfirmation = ({
  isOpen = false,
  isMultiple = false,
  setIsOpen,
  isReject,
  handleContinue,
  handleReturnAction,
  hasAuthority
}: ModalConfirmationProps) => {
  const methods = useFormContext()
  const { control, watch } = methods

  const justification = watch('justification')
  return (
    <Modal
      open={isOpen}
      setOpen={setIsOpen}
      title={isReject ? 'Reprovar negociação' : 'Aprovar negociação'}
      showReturn
      showClose
      returnText="Cancelar"
      buttonText={isReject ? 'Reprovar' : 'Aprovar'}
      buttonAction={handleContinue}
      returnAction={handleReturnAction}
      buttonDisabled={isReject && justification === ''}
    >
      <S.Wrapper>
        {isReject ? (
          'Insira uma justificativa para a reprovação.'
        ) : !hasAuthority ? (
          `Tem certeza que deseja aprovar ${
            isMultiple ? 'estas negociações' : 'esta negociação'
          }?`
        ) : (
          <>
            <Alert kind="warning" title="Fora da alçada" fullWidth />
            Ao aprovar esta negociação, sua OV permanecerá
            <br /> pendente, aguardando a aprovação da diretoria.
          </>
        )}
        {isReject && (
          <S.FieldWrapper>
            <Controller
              name="justification"
              control={control}
              render={({ field: { name, value, onChange } }) => (
                <Input
                  label="Descrição"
                  name={name}
                  value={value}
                  onChange={onChange}
                  placeholder="Descreva aqui a justificativa"
                  required
                  rows={3}
                  height={90}
                  maxLength={255}
                />
              )}
            />
          </S.FieldWrapper>
        )}
      </S.Wrapper>
    </Modal>
  )
}

export default ModalConfirmation
